export interface DataIn {
  icon?: 'string',
  temperature?: string | number, // °
  temperatureFeelsLike?: string | number, // °
  drewPoint?: number, // °
  solarIrradiation?: number, // %
  windSpeed?: number, // m/s
  daylight?: number | boolean, // lx | boolean
  humidity?: number, // %
  sunset?: string, // time
  sunrise?: string, // time
  windDirection?: number, // degrees
  pressure?: number, // hPa
  rain?: number | boolean, // mm | boolean
  snow?: number | boolean, // mm | boolean
  storm?: boolean, // boolean
  fog?: boolean, // boolean
}